interface BuildAuthSessionRecoveryUrlOptions {
  destination?: string
  additionalParams?: Record<string, string>
}

export function buildAuthSessionRecoveryUrl({
  destination = 'HOME',
  additionalParams = {},
}: BuildAuthSessionRecoveryUrlOptions = {}) {
  const searchParams = new URLSearchParams(additionalParams)
  searchParams.delete('authError')
  searchParams.delete('authRetry')
  searchParams.delete('sessionReset')
  searchParams.delete('forceRefresh')
  searchParams.set('destination', destination)
  searchParams.set('forceRefresh', 'true')

  return `/login?${searchParams.toString()}`
}
